module.exports = __webpack_public_path__ + "static/14-5356d9a5d6ac2e20244114d4792f8a4c.jpg";